import { getParent, types } from 'mobx-state-tree';
import { api } from 'src/api';
import { createAsync } from 'src/utils/asyncModel';
const addNewPropertyUtilityConfigAsync = createAsync(body => {
  return async function addNewPropertyUtilityConfig(options) {
    const resp = await api.PropertyUtility.addPropertyUtilityConfiguration(body, options);
    return resp;
  };
});
const addNewPropertyUtilityConfigBatchAsync = createAsync(body => {
  return async function addNewPropertyUtilityConfigBatch(options) {
    const resp = await api.PropertyUtility.addPropertyUtilitiesConfigurationBatch(body, options);
    return resp;
  };
});
const getGwdHistoryAsync = createAsync(body => {
  return async function getGwdHistory(options) {
    const resp = await api.PropertyUtility.getGwdHistory(body, options);
    const _getParent = getParent(this),
      propertyUtility = _getParent.propertyUtility;
    propertyUtility.setHistoryByPropertyUtilityId(body.propertyUtilityId, resp);
    return resp;
  };
});
const updateNewPropertyUtilityConfigAsync = createAsync(body => {
  return async function updateNewPropertyUtilityConfig(options) {
    const resp = await api.PropertyUtility.updatePropertyUtilityConfiguration(body, options);
    return resp;
  };
});
const updateNewPropertyUtilityConfigBatchAsync = createAsync(body => {
  return async function updateNewPropertyUtilityConfigBatch(options) {
    const resp = await api.PropertyUtility.updatePropertyUtilitiesConfigurationBatch(body, options);
    return resp;
  };
});
const deleteNewPropertyUtilityConfigAsync = createAsync(body => {
  return async function deleteNewPropertyUtilityConfig(options) {
    const resp = await api.PropertyUtility.deletePropertyUtilityConfiguration(body, options);
    const _getParent2 = getParent(this),
      addNewProperty = _getParent2.addNewProperty;
    addNewProperty.utilitiesSetupV2.removeUtilityToDelete({
      id: body.utilityId
    });
    return resp;
  };
});
const createPropertyUtilitiesAsync = createAsync(body => {
  return async function createPropertyUtilities(options) {
    const resp = await api.PropertyUtility.createPropertyUtilitiesBatch(body, options);

    // const { addNewProperty } = getParent<typeof rootStore>(this);
    // addNewProperty.utilitiesSetupV2.removeUtilityToDelete({
    //   id: body.utilityId,
    // });
    return resp;
  };
});
const updatePropertyUtilitiesAsync = createAsync(body => {
  return async function updatePropertyUtilities(options) {
    const resp = await api.PropertyUtility.updatePropertyUtilitiesBatch(body, options);

    // const { addNewProperty } = getParent<typeof rootStore>(this);
    // addNewProperty.utilitiesSetupV2.removeUtilityToDelete({
    //   id: body.utilityId,
    // });
    return resp;
  };
});
const getPropertyUtilityInfoByUtilityAndPropertyAsync = createAsync(body => {
  return async function getPropertyUtilityInfoByUtilityAndProperty(options) {
    const resp = await api.PropertyUtility.getPropertyUtilityInfoByUtilityAndProperty(body, options);
    return resp;
  };
});
const getPropertyUtilitiesByPropertyAsync = createAsync(body => {
  return async function getPropertyUtilitiesByProperty(options) {
    const resp = await api.PropertyUtility.getPropertyUtilitiesByPropertyId(body, options);
    const _getParent3 = getParent(this),
      addNewProperty = _getParent3.addNewProperty;
    addNewProperty.utilitiesSetupV2.removeUtilityToDelete({
      id: body.utilityId
    });
    return resp;
  };
});
const deletePropertyUtilityAsync = createAsync(body => {
  return async function deletePropertyUtility(options) {
    const resp = await api.PropertyUtility.deletePropertyUtility(body, options);
    return resp;
  };
});
const updatePropertyUtilityAsync = createAsync(body => {
  return async function updatePropertyUtilities(options) {
    const resp = await api.PropertyUtility.updatePropertyUtility(body, options);
    return resp;
  };
});
const updateSubmeterConfigAsync = createAsync(body => {
  return async function updateSubmeterConfig(options) {
    const resp = await api.PropertyUtility.updateSubmeterConfig(body, options);
    return resp;
  };
});
const getSubmeterConfigV2Async = createAsync(body => {
  return async function getSubmeterConfigV2(options) {
    const resp = await api.PropertyUtility.getSubmeterConfigV2(body, options);
    return resp;
  };
});
const updateCsvColumnMapAsync = createAsync(body => {
  return async function updateCsvColumnMap(options) {
    const resp = await api.PropertyUtility.updateCsvColumnMap(body, options);
    return resp;
  };
});
const GwdHistoryItem = types.model('GwdHistoryItem', {
  applyOnAllocationCycleId: types.maybeNull(types.string),
  createdOn: types.string,
  goodWillDeduction: types.number,
  updateComment: types.maybeNull(types.string),
  updatedByUserAccountId: types.string
});

/**
 * The utility account numbers that route inbound bills to a property (LB-5778).
 *
 * The read is deliberately NOT silent: unlike an additive banner, this is a screen the PM opened on
 * purpose, so a failure to load should say so rather than render an empty list that looks like
 * "no numbers configured" -- which would invite them to add a duplicate.
 */
const getPropertyUtilityAccountsAsync = createAsync(body => {
  return async function getPropertyUtilityAccounts(options) {
    const resp = await api.Properties.getPropertyUtilityAccounts(body, options);
    return resp;
  };
});
const addPropertyUtilityAccountAsync = createAsync(body => {
  return async function addPropertyUtilityAccount(options) {
    const resp = await api.Properties.addPropertyUtilityAccount(body, options);
    return resp;
  };
});
const updatePropertyUtilityAccountAsync = createAsync(body => {
  return async function updatePropertyUtilityAccount(options) {
    const resp = await api.Properties.updatePropertyUtilityAccount(body, options);
    return resp;
  };
});
const deletePropertyUtilityAccountAsync = createAsync(body => {
  return async function deletePropertyUtilityAccount(options) {
    const resp = await api.Properties.deletePropertyUtilityAccount(body, options);
    return resp;
  };
});
const PropertyUtilityStore = types.model('PropertyUtilityStore', {
  addNewPropertyUtilityConfigAsync,
  addNewPropertyUtilityConfigBatchAsync,
  getGwdHistoryAsync,
  historyByPropertyUtilityId: types.map(types.array(GwdHistoryItem)),
  updateNewPropertyUtilityConfigAsync,
  updateNewPropertyUtilityConfigBatchAsync,
  deleteNewPropertyUtilityConfigAsync,
  createPropertyUtilitiesAsync,
  getPropertyUtilitiesByPropertyAsync,
  deletePropertyUtilityAsync,
  updatePropertyUtilitiesAsync,
  getPropertyUtilityInfoByUtilityAndPropertyAsync,
  updatePropertyUtilityAsync,
  updateSubmeterConfigAsync,
  getSubmeterConfigV2Async,
  updateCsvColumnMapAsync,
  getPropertyUtilityAccountsAsync,
  addPropertyUtilityAccountAsync,
  updatePropertyUtilityAccountAsync,
  deletePropertyUtilityAccountAsync
}).actions(self => ({
  setHistoryByPropertyUtilityId(id, data) {
    self.historyByPropertyUtilityId.set(id, data.response);
  }
}));
export const propertyUtility = types.optional(PropertyUtilityStore, {});